import { getBooleanFromValue } from '@/global/utils/utils'

const TAB_KEY = 'basicInfo'
export default {
  data () {
    return {
      basicInfoKey: TAB_KEY,
      createInitialUser: false
    }
  },

  computed: {
    basicInfoCreateConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        validationErrors: this.validationErrors,
        tabContent: [
          {
            component: this.columnsContentComponent,
            title: this.$t('base/profile.basic_info'),
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'name',
                    label: this.$t('base/company.name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'address',
                    label: this.$t('base/company.address'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'postal_code',
                    label: this.$t('base/company.postal_code'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'city',
                    label: this.$t('base/company.city'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'country',
                    label: this.$t('base/company.country'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'identification_number',
                    label: this.$t('base/company.identification_number'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'type_id',
                    label: this.$t('base/company.type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'company-types'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'language_id',
                    label: this.$t('base.language'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'languages/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'trip_config_id',
                    label: this.$t('base/company.trip_config'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'trip-configs'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'create_initial_user',
                    label: this.$t('base/company.create_initial_user'),
                    type: 'base-switch',
                    creatable: true,
                    editable: true,
                    visible: true,
                    onChange: (event) => this.onCreateInitialUser(event)
                  },
                  {
                    key: 'first_name',
                    label: this.$t('base/company.user_first_name'),
                    creatable: true,
                    editable: true,
                    visible: this.createInitialUser
                  },
                  {
                    key: 'last_name',
                    label: this.$t('base/company.user_last_name'),
                    creatable: true,
                    editable: true,
                    visible: this.createInitialUser
                  },
                  {
                    key: 'username',
                    label: this.$t('base/company.user_username'),
                    creatable: true,
                    editable: true,
                    visible: this.createInitialUser
                  },
                  {
                    key: 'email',
                    label: this.$t('base/company.user_email'),
                    creatable: true,
                    editable: true,
                    visible: this.createInitialUser
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    onCreateInitialUser (event) {
      this.createInitialUser = getBooleanFromValue(event)
    }
  }
}
